import * as yup from 'yup';

yup.addMethod(yup.string, 'phone', function () {
  return this.test('phone', 'ERROR.PHONE', (str) => {
    if (!str || str === '') return true;

    if (str.length > 25) return false;

    const regex = new RegExp(/^[\d+(\-?)+(.?)+((?)+()?)+(\s?)+(+?)+(/?)]+[\d]$/g);
    return regex.test(str);
  });
});
